import Vue from 'vue'
import App from './App.vue'

import Buefy from 'buefy'
import VueI18n from 'vue-i18n';
import CountryFlag from 'vue-country-flag';

import router from './router'
import messages from './locales/translations.js'

import '@/assets/css/main.css'
import '@/assets/css/variables.scss'


Vue.config.productionTip = false;

Vue.use(Buefy);
Vue.use(VueI18n);
Vue.component("country-flag", CountryFlag);

if (localStorage.language == null) {
  localStorage.language = navigator.language.split("-")[0];
}

const i18n = new VueI18n({
  locale: localStorage.language,
  fallbackLocale: "en",
  messages
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
